module.exports = __webpack_public_path__ + "static/Gerald Video Page-b9b590132f3363b33b3e28ee9fc99208.jpg";